




























import { Component, Vue } from 'vue-property-decorator';
import {
  GetClientsRequestSortByEnum,
  GetClientsRequestSortOrderEnum,
  RoleDTO,
} from '@/api';
import { rolesModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import RolePermission from './RolePermission.vue';

interface usersSearch {
  sortBy?: GetClientsRequestSortByEnum;
  sortOrder?: GetClientsRequestSortOrderEnum;
  STYLIST?: string[];
  STATUS?: string[];
}

@Component({
  name: 'users',
  components: {
    UserMenu,
    MainNavbar,
    RolePermission,
  },
})
export default class Users extends Vue {
  get loading() {
    return rolesModule.listLoading;
  }

  get roles() {
    return rolesModule.list;
  }

  async created() {
    rolesModule.fetchRoles();
  }

  editRole(role: RoleDTO) {
    // eslint-disable-next-line no-console
    console.log(role);

    (this.$refs['role-permission'] as RolePermission).open(role);
  }

  get total() {
    return this.roles.length;
  }
}
